import graphql from 'babel-plugin-relay/macro';
import { fetchQuery } from 'react-relay';
import AbEnvironment from '../auth/AbEnvironment';

const abEnvironment = new AbEnvironment();
      
const query = graphql`
query CustomerFetchQuery($searchParm: String!, $activeOnly: Int, $first: Int) {
    accountsearchbycustomername2(search: $searchParm, activeonly: $activeOnly, first: $first) {
      totalCount
      nodes {
        accountId
        accountType
        accountNum
        accountName
        description
        contactLastName
        contactFirstName
        contactEmail
        contactPhone
        address1
        address2
        city
        state
        country
        postalCode
        stripeCid
        dwollaCid
        accountStatus
        useBudgets
        preApproveSubs
        rPreApproveSubs
        customerStatus
      }
    }
  }
`;

function fetch(search, activeOnly, first) {
  const variables = {
    searchParm: search,
    activeOnly: activeOnly,
    first: first
  }
  
  return fetchQuery(
    abEnvironment.getEnvironment(),
    query,
    variables
  );
}
/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default { fetch };

